import React, { useState, useEffect, useRef } from 'react';
import QRCode from 'qrcode';
import './KYPList.css';
import '../Soc/Soc.css';
import PropertiesService from '../../Services/PropertiesService';
import KypDetailsUiCard from '../kypDetails/KypDetailsUiCard';
import userIcon from "./../../assets/Images/ChatBot/user.png";
import { toast } from 'react-toastify';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';


import {
    FaEnvelope,
    FaPhone,
    FaMapMarkerAlt,
    FaFilePdf,
    FaCheckCircle,
    FaCalendarAlt,
    FaBuilding,
    FaHome,
    FaFileContract,
    FaMoneyBillWave,
    FaFileAlt,
    FaUser,
    FaUniversity,
    FaFileInvoiceDollar,
    FaHardHat,
    FaRoad,
    FaIdCard,
    FaUsers,
    FaDraftingCompass,
    FaToolbox,
    FaInfoCircle,
    FaMountain,
    FaClock,
    FaUserTie,
    FaTools,
    FaDownload,
    FaQrcode,
    FaEdit,
} from "react-icons/fa";
import ProgressbarForKypForm from "../ProgressbarForKypForm/ProgressbarForKypForm";
import loader from "./../../assets/Images/Request_Property/Loader.gif";
import Product from '../RazorPay';
import PaymentPreviewCard from '../PaymentPreviewCard/PaymentPreviewCard';
import logo from '../../assets/Images/LOGOS/Docity_Logo.png';
import requestsService from '../../Services/requests';
import Modal from '../Modal/Modal';
import FetchingCard from '../FetchingCard/FetchingCard';
import KnowYourProperty from '../KYP/KnowYourProperty';

const KYPList = () => {
    const certificateRef = useRef(null);
    const getPublicOrigin = () => {
        if (typeof window === 'undefined') return 'https://docity-user.netlify.app';
        const origin = window.location.origin;
        if (origin && !origin.includes('localhost') && !origin.includes('127.0.0.1')) {
            return origin;
        }
        const host = window.location.hostname;
        if (host && host !== 'localhost' && host !== '127.0.0.1') {
            return origin;
        }
        const port = window.location.port ? `:${window.location.port}` : ':3000';
        return `http://192.168.1.8${port}`;
    };
    const buildCertificateDownloadRoute = (type, certificateId, meta = {}) => {
        if (!certificateId) return '';
        const base = `${getPublicOrigin()}/#/certificate-download?type=${encodeURIComponent(type)}&id=${encodeURIComponent(certificateId)}`;
        const params = new URLSearchParams();
        if (meta.ownerName) params.append('name', meta.ownerName);
        if (meta.address) params.append('addr', meta.address);
        if (meta.expiresAt) params.append('exp', meta.expiresAt);
        if (meta.issuedAt || meta.createdAt) params.append('iss', meta.issuedAt || meta.createdAt);
        const query = params.toString();
        return query ? `${base}&${query}` : base;
    };
    const buildCertificateDownloadRouteBase = (type) => `${getPublicOrigin()}/#/certificate-download?type=${type}&id=`;

    const sortKypsOrderWise = (items = []) => {
        return [...items].sort((a, b) => {
            const timeA = new Date(a?.updatedAt || a?.createdAt || 0).getTime();
            const timeB = new Date(b?.updatedAt || b?.createdAt || 0).getTime();
            return timeB - timeA;
        });
    };

    const formatCertificateDate = (value) => {
        if (!value) return new Date().toISOString().split('T')[0];

        const parsedDate = new Date(value);
        if (!Number.isNaN(parsedDate.getTime())) {
            return parsedDate.toISOString().split('T')[0];
        }

        return new Date().toISOString().split('T')[0];
    };

    const formatDisplayDate = (dateValue) => {
        if (!dateValue) return 'N/A';
        const parsedDate = new Date(dateValue);
        if (Number.isNaN(parsedDate.getTime())) return 'N/A';
        return parsedDate.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    const formatLabel = (value = '') => value
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase())
        .trim();

    const generateUniqueSealCode = (certificateId, ownerName, issuedDate) => {
        const source = `${certificateId || 'DOCITY'}|${ownerName || 'OWNER'}|${issuedDate || new Date().toISOString()}`;
        let hash = 0;

        for (let i = 0; i < source.length; i += 1) {
            hash = (hash << 5) - hash + source.charCodeAt(i);
            hash |= 0;
        }

        const encoded = Math.abs(hash).toString(36).toUpperCase().padStart(8, '0').slice(0, 8);
        return `DC-${encoded}`;
    };

    const getKypAddress = (item = {}) => {
        return item?.googleLocation || [item?.location, item?.pd, item?.sro, item?.postalCode]
            .filter(Boolean)
            .join(', ');
    };

    const collectKypCertificateFiles = (item = {}) => {
        const files = [];
        const seen = new Set();
        const skippedKeys = new Set(['neighbourDetails', 'qrCodeData']);

        const addFile = (url, label, manualDate) => {
            if (typeof url !== 'string' || !/^https?:\/\//i.test(url) || seen.has(url)) {
                return;
            }

            seen.add(url);
            files.push({
                name: label || `Document ${files.length + 1}`,
                data: url,
                manualDate: formatCertificateDate(manualDate || item?.updatedAt || item?.createdAt),
            });
        };

        const walk = (value, label = 'Document') => {
            if (!value) return;

            if (Array.isArray(value)) {
                value.forEach((entry, index) => walk(entry, `${label} ${index + 1}`));
                return;
            }

            if (typeof value === 'string') {
                addFile(value, label);
                return;
            }

            if (typeof value !== 'object') return;

            if (value?.file || value?.url) {
                addFile(
                    value?.file || value?.url,
                    value?.fields?.typeofdocument || value?.note || label,
                    value?.fields?.datethedocumentwasissued || value?.manualDate || value?.date
                );
            }

            Object.entries(value).forEach(([key, nestedValue]) => {
                if (skippedKeys.has(key) || key === 'file' || key === 'url') return;
                walk(nestedValue, formatLabel(key));
            });
        };

        walk(item);
        return files;
    };

    const matchesKypSearch = (item = {}, value = '') => {
        const normalizedValue = value.toLowerCase();
        const address = getKypAddress(item).toLowerCase();

        return (
            item.ownerName?.toLowerCase().includes(normalizedValue) ||
            item.email?.toLowerCase().includes(normalizedValue) ||
            item.location?.toLowerCase().includes(normalizedValue) ||
            item.googleLocation?.toLowerCase().includes(normalizedValue) ||
            address.includes(normalizedValue)
        );
    };

    const itemsPerPage = 5;
    const [SuccessStatus, setSuccessStatus] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    let [kpifilter, setKpiFilter] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [FilteredKyps, setFilteredKyps] = useState([]);
    const filteredList = kpifilter.filter((item) => matchesKypSearch(item, searchTerm));

    const currentItems = filteredList.slice(indexOfFirstItem, indexOfLastItem);
    const [showTabs, setShowTabs] = useState(true);
    const [editedRow, setEditedRow] = useState({});
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [pendingPaymentItem, setPendingPaymentItem] = useState(null);
    const [showKypEditModal, setShowKypEditModal] = useState(false);
    const [editingKypId, setEditingKypId] = useState('');

    const [GatewayModel, showGatewayModel] = useState(false)
    const [activeTab2, setActiveTab2] = useState("overview");
    const [activeTabnew, setActiveTabNew] = useState("detailed");
    const [token, setToken] = useState("");
    const [userDetails, setUserDetails] = useState([]);
    const [selectedItem, setSelectedItem] = useState([]);
    const [showDetails, setShowDetails] = useState(false);
    const [showTableDetails, setShowTableDetails] = useState(false);
    const [kyplist, setKyplist] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [KypListLoading, setKypListLoading] = useState(false)
    const [paymentStatus, setPaymentStatus] = useState(false);
    const [showSocCertificate, setShowSocCertificate] = useState(false);
    const [showKypVoucher, setShowKypVoucher] = useState(false);
    const [socCertificateData, setSocCertificateData] = useState(null);
    const [effectiveQrCode, setEffectiveQrCode] = useState('');
    const [selectedCertificateItem, setSelectedCertificateItem] = useState(null);

    useEffect(() => {
        let isMounted = true;
        const generateQr = async () => {
            if (!socCertificateData) {
                setEffectiveQrCode('');
                return;
            }

            const certId =
                socCertificateData?.certificateId ||
                socCertificateData?.OCCertificateId ||
                socCertificateData?._id ||
                socCertificateData?.id ||
                selectedItem?.OCCertificateId ||
                selectedItem?._id;

            const certMeta = {
                ownerName: socCertificateData?.ownerName || selectedItem?.ownerName || '',
                address: socCertificateData?.address || selectedItem?.location || selectedItem?.address || '',
                expiresAt: socCertificateData?.expiresAt || '',
                issuedAt: socCertificateData?.createdAt || selectedItem?.createdAt || '',
            };
            const routeUrl = buildCertificateDownloadRoute('oc', certId, certMeta);

            const directUrl =
                socCertificateData?.downloadUrl ||
                socCertificateData?.certificateDownloadUrl ||
                socCertificateData?.pdfUrl ||
                socCertificateData?.certificateUrl ||
                socCertificateData?.fileUrl ||
                socCertificateData?.url;

            const isValidHttpDirectUrl =
                typeof directUrl === 'string' &&
                /^https?:\/\//i.test(directUrl) &&
                !directUrl.includes('blob:') &&
                !directUrl.includes('#/certificate-download');

            const targetUrl = isValidHttpDirectUrl ? directUrl : (routeUrl || directUrl || '');

            if (targetUrl) {
                try {
                    const dataUrl = await QRCode.toDataURL(targetUrl, {
                        margin: 1,
                        width: 256,
                        color: { dark: '#000000', light: '#ffffff' }
                    });
                    if (isMounted) setEffectiveQrCode(dataUrl);
                } catch (err) {
                    console.error('[KYPList] Error generating QR code:', err);
                    if (isMounted) setEffectiveQrCode(socCertificateData?.qrCodeData || '');
                }
            } else if (socCertificateData?.qrCodeData) {
                if (isMounted) setEffectiveQrCode(socCertificateData.qrCodeData);
            }
        };

        generateQr();
        return () => { isMounted = false; };
    }, [socCertificateData, selectedItem]);
    const [generatingSocId, setGeneratingSocId] = useState('');
    const [isDownloading, setIsDownloading] = useState(false);
    const [socCertificateMap, setSocCertificateMap] = useState({});
    const [socHistoryByKypId, setSocHistoryByKypId] = useState({});
    const [landUseUploadingById, setLandUseUploadingById] = useState({});
    const [landUseUploadErrorById, setLandUseUploadErrorById] = useState({});

    const [activeTab4, setActiveTab4] = useState("east");

    const openKypEditModal = (item, event) => {
        event?.stopPropagation?.();
        setEditingKypId(String(item?._id || ''));
    };

    const closeKypEditModal = async () => {
        setEditingKypId('');
        await getkyplist();
    };

    const directions = ["east", "west", "south", "north"];
    const tabs = [
        { id: "overview", label: "Owner Info", icon: FaHome },
        { id: "details", label: "Property Details", icon: FaBuilding },
        { id: "construction", label: "Construction", icon: FaHardHat },
        { id: "documents", label: "Documents", icon: FaFilePdf },
        { id: "neighbors", label: "Neighbours", icon: FaUsers },
        { id: "department", label: "Department", icon: FaUsers },
        { id: "declarations", label: "Declarations", icon: FaFileContract },
    ];

    const isKypPaid = (item) =>
        item?.Payment_Status === true ||
        String(item?.paymentStatus || "").toLowerCase() === "paid";

    const getKypItemKey = (item = {}) => String(item?._id || item?.id || '');

    const normalizeOcList = (response) => {
        const raw = response?.data ?? response?.result ?? response;
        if (Array.isArray(raw)) return raw;
        if (raw && typeof raw === 'object') return [raw];
        return [];
    };

    const fetchOcCertificateById = async (item) => {
        if (!item?.OCCertificateId) return null;

        const ocResponse = await requestsService.getSingleOc({ OCId: item.OCCertificateId });
        console.log(ocResponse, 'ocResponse2222')
        const ocList = normalizeOcList(ocResponse);
        return ocList[0] || null;
    };

    const loadExistingOcCertificates = async (kypList = []) => {
        const withOcId = kypList.filter((kyp) => kyp?.OCCertificateId);
        if (!withOcId.length) {
            setSocHistoryByKypId({});
            return;
        }

        const results = await Promise.allSettled(
            withOcId.map(async (kyp) => {
                const latestOc = await fetchOcCertificateById(kyp);
                if (!latestOc) return null;
                return [getKypItemKey(kyp), latestOc];
            })
        );

        const nextMap = {};
        results.forEach((result) => {
            if (result.status !== 'fulfilled') return;
            const pair = result.value;
            if (!pair) return;
            nextMap[pair[0]] = pair[1];
        });

        setSocHistoryByKypId(nextMap);
    };

    const handleCardClick = async (item) => {
        setSelectedItem(item);
        console.log(item, 'selected item')
        setShowDetails(true);
        // On KYP click:
        // - if `OCCertificateId` exists, fetch OC using that id and cache it
        // - if OC is not there, do not generate here
        // - generation should happen only when the SOC button is clicked
        if (item?.OCCertificateId) {
            const itemKey = getKypItemKey(item);
            const existingCertificate = socCertificateMap[itemKey] || socHistoryByKypId[itemKey];

            if (!existingCertificate) {
                try {
                    const fetchedCertificate = await fetchOcCertificateById(item);
                    if (fetchedCertificate) {
                        setSocCertificateMap((prev) => ({
                            ...prev,
                            [itemKey]: fetchedCertificate,
                        }));
                        setSocHistoryByKypId((prev) => ({
                            ...prev,
                            [itemKey]: fetchedCertificate,
                        }));
                    }
                } catch (error) {
                    console.error('Failed to fetch existing OC certificate:', error);
                }
            }
        }
        // if (isKypPaid(item)) {
        //     setShowDetails(true);
        //     const itemKey = item?._id || item?.id;
        //     if (!socCertificateMap[itemKey]) {
        //         await handleGenerateSocCertificate(item, false);
        //     }
        // } else {
        //     setPendingPaymentItem(item);
        //     setShowPaymentModal(true);
        // }
    };

    const handleGenerateSocCertificate = async (item, shouldOpen = true) => {
        const itemKey = getKypItemKey(item);

        const setCertificateState = (certificate) => {
            if (!certificate) return;

            const normalizedCertificate = {
                ...certificate,
                downloadUrl:
                    certificate?.downloadUrl ||
                    certificate?.certificateDownloadUrl ||
                    certificate?.pdfUrl ||
                    certificate?.certificateUrl ||
                    buildCertificateDownloadRoute('oc', certificate?.certificateId || item?.OCCertificateId || item?._id || item?.id, {
                        ownerName: certificate?.ownerName || item?.ownerName || '',
                        address: certificate?.address || item?.location || item?.address || '',
                        expiresAt: certificate?.expiresAt || '',
                        issuedAt: certificate?.createdAt || item?.createdAt || '',
                    }),
            };

            setSelectedCertificateItem(item);
            setSocCertificateData(normalizedCertificate);
            setSocCertificateMap((prev) => ({
                ...prev,
                [itemKey]: normalizedCertificate,
            }));
            setSocHistoryByKypId((prev) => ({
                ...prev,
                [itemKey]: normalizedCertificate,
            }));

            if (shouldOpen) {
                setShowSocCertificate(true);
            }
        };

        const existingCertificate = socCertificateMap[itemKey] || socHistoryByKypId[itemKey];
        if (existingCertificate) {
            setCertificateState(existingCertificate);
            return existingCertificate;
        }

        setGeneratingSocId(itemKey || 'generating');
        console.log(item?.OCCertificateId, 'generating certificate for item')

        try {
            if (item?.OCCertificateId) {
                const fetchedCertificate = await fetchOcCertificateById(item);

                if (fetchedCertificate) {
                    setCertificateState(fetchedCertificate);
                    return fetchedCertificate;
                }
            }

            console.log('No OCCertificateId found on item, proceeding to generate OC certificate')
            const filesData = collectKypCertificateFiles(item);

            if (!filesData.length) {
                toast.error('No KYP documents available to generate OC certificate.');
                return null;
            }

            const response = await PropertiesService.generateoc({
                userId: item?.userId,
                filesData,
                kypId: item?._id || item?.id,
                certificateDownloadRouteBase: buildCertificateDownloadRouteBase('oc'),
            });

            const generatedCertificate = response?.data || response;
            setCertificateState(generatedCertificate);
            return generatedCertificate;
        } catch (error) {
            console.error('Failed to fetch or generate OC certificate:', error);
            toast.error('Failed to fetch or generate OC certificate for this KYP.');
            return null;
        } finally {
            setGeneratingSocId('');
        }
    };

    const handleViewSocCertificate = async (item) => {
        const itemKey = getKypItemKey(item);
        const generatedCertificate = await handleGenerateSocCertificate(item, false);
        const certToShow = generatedCertificate || socCertificateMap[itemKey] || socHistoryByKypId[itemKey];
        if (!certToShow) {
            toast.error('OC certificate not available. Please try again.');
            return;
        }

        setSelectedCertificateItem(item);
        setSocCertificateData(certToShow);
        setShowSocCertificate(true);
    };

    const getVoucherExpiryDate = (item, certificate) => {
        if (certificate?.expiresAt) return certificate.expiresAt;
        const source = item?.updatedAt || item?.createdAt;
        if (!source) return '';
        const parsed = new Date(source);
        if (Number.isNaN(parsed.getTime())) return '';
        parsed.setFullYear(parsed.getFullYear() + 2);
        return parsed.toISOString();
    };

    const handleViewKypVoucher = async (item) => {
        const itemKey = getKypItemKey(item);
        const generatedCertificate = await handleGenerateSocCertificate(item, false);
        const certToUse = generatedCertificate || socCertificateMap[itemKey] || socHistoryByKypId[itemKey] || null;
        setSelectedCertificateItem(item);
        setSocCertificateData(certToUse);
        setShowKypVoucher(true);
    };

    const downloadCertificate = async () => {
        if (isDownloading) return;
        setIsDownloading(true);

        try {
            const element = certificateRef.current;
            if (!element) return;

            const safeFileName = String(
                socCertificateData?.certificateId ||
                selectedCertificateItem?.ownerName ||
                'Certificate'
            )
                .replace(/[^a-zA-Z0-9-_]/g, '-')
                .replace(/-+/g, '-')
                .replace(/^-|-$/g, '') || 'Certificate';

            const captureCertificate = async (scaleValue) => {
                return await html2canvas(element, {
                    scale: scaleValue,
                    useCORS: true,
                    allowTaint: true,
                    imageTimeout: 0,
                    logging: false,
                    backgroundColor: '#d8e5e5',
                    windowWidth: element.scrollWidth,
                    windowHeight: element.scrollHeight,
                    ignoreElements: (node) => node?.dataset?.html2canvasIgnore === 'true',
                    onclone: (clonedDoc) => {
                        clonedDoc.querySelectorAll('[data-export-hide="true"]').forEach((btn) => {
                            btn.style.display = 'none';
                        });

                        const style = clonedDoc.createElement('style');
                        style.innerHTML = `
                            .kyp-oc-certificate, .kyp-oc-certificate * {
                                animation: none !important;
                                transition: none !important;
                                font-family: Arial, Helvetica, sans-serif !important;
                            }
                        `;
                        clonedDoc.head.appendChild(style);
                    },
                });
            };

            let canvas = null;
            try {
                canvas = await captureCertificate(2);
            } catch {
                canvas = await captureCertificate(1.2);
            }

            const imgData = canvas.toDataURL('image/png', 1.0);

            try {
                const pdf = new jsPDF({
                    orientation: canvas.width > canvas.height ? 'l' : 'p',
                    unit: 'px',
                    format: [canvas.width, canvas.height],
                    compress: true,
                });

                pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height, undefined, 'FAST');
                pdf.save(`OC-${safeFileName}.pdf`);
            } catch {
                const link = document.createElement('a');
                link.href = imgData;
                link.download = `OC-${safeFileName}.png`;
                document.body.appendChild(link);
                link.click();
                link.remove();
            }

            toast.success('Certificate downloaded successfully!');
        } catch (error) {
            console.error('Download failed:', error);
            toast.error('Download failed');
        } finally {
            setIsDownloading(false);
        }
    };

    const currentNeighbour = selectedItem?.neighbourDetails?.find(
        (item) => item.direction.toLowerCase() === activeTab4
    );
    const kyplocalstorage = localStorage.getItem('kypedit')

    useEffect(() => {
        setKypListLoading(true)
        document.body.style.overflow = "auto";
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        setToken(localStorage.getItem("token") || "");
        setUserDetails(userDetails);
        getkyplist()
        console.log(kyplocalstorage, 'kyplocalstorage')
        if (kyplocalstorage == 'kypedit') {
            getkyplist()
            localStorage.removeItem('kypedit')
        }
    }, [kyplocalstorage]);

    const getkyplist = async () => {
        const token2 = token;
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        if (!userDetails || !userDetails.user_id) {
            setKypListLoading(false);
            return;
        }
        try {
            const response = await PropertiesService.getKpiLists({ userId: userDetails.user_id });
            const filteredData = response.data.filter(
                (item) => item.userId === userDetails?.user_id
            );
            const filterFilledKYPS = filteredData.filter(
                (x) =>
                    x?.isFilled == true ||
                    isKypPaid(x)
            )
            const sortedKyps = sortKypsOrderWise(filterFilledKYPS);
            setKyplist(sortedKyps);
            setKypListLoading(false)
            setKpiFilter((kpifilter = sortedKyps));

            await loadExistingOcCertificates(sortedKyps);
        } catch (error) {
            console.error("Error:", error.response?.data || error.message);
            setSocHistoryByKypId({});
        }
    };

    const onError = () => {
        setIsLoading(false);
        setHasError(true);
    };

    const backbtnclk = () => {
        setShowDetails(false);
        setShowTableDetails(true);
        setShowTabs(true);
        setEditedRow(false);
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        const filteredPropertieslist = kyplist.filter((item) => matchesKypSearch(item, value));
        const sortedKyps = sortKypsOrderWise(filteredPropertieslist);
        setFilteredKyps(sortedKyps);
        setKpiFilter(sortedKyps);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    const onLoad3 = () => {
        setIsLoading(false);
        setHasError(false);
    };

    const handleUploadLandUseCertificate = async (item, file) => {
        if (!item?._id || !file) return;
        const itemId = String(item._id);
        const userId = item?.userId || userDetails?.user_id;
        if (!userId) {
            toast.error('User not found');
            return;
        }

        setLandUseUploadingById((prev) => ({ ...prev, [itemId]: true }));
        setLandUseUploadErrorById((prev) => ({ ...prev, [itemId]: '' }));

        try {
            const formData = new FormData();
            formData.append('image', file);
            const uploadResponse = await PropertiesService.UploadFiles(formData);
            if (typeof uploadResponse === 'string' && uploadResponse.toLowerCase().includes('error')) {
                throw new Error(uploadResponse);
            }

            const landUseCertificateUrl =
                uploadResponse?.Location ||
                uploadResponse?.previewUrl ||
                uploadResponse?.downloadUrl ||
                uploadResponse?.files?.[0]?.url ||
                '';

            if (!landUseCertificateUrl) {
                throw new Error('Unable to resolve uploaded certificate URL');
            }

            const updatePayload = {
                KypId: itemId,
                _id: itemId,
                userId,
                landUseCertificate: landUseCertificateUrl,
            };

            const updateResponse = await PropertiesService.updateKnowYourProperty(updatePayload);
            if (typeof updateResponse === 'string' && updateResponse.toLowerCase().includes('error')) {
                throw new Error(updateResponse);
            }

            const updatedData = updateResponse?.data || {};
            const finalUrl = updatedData?.landUseCertificate || landUseCertificateUrl;

            setKyplist((prev) =>
                prev.map((kyp) =>
                    String(kyp?._id) === itemId ? { ...kyp, landUseCertificate: finalUrl } : kyp
                )
            );
            setKpiFilter((prev) =>
                prev.map((kyp) =>
                    String(kyp?._id) === itemId ? { ...kyp, landUseCertificate: finalUrl } : kyp
                )
            );
            setSelectedItem((prev) =>
                prev && String(prev?._id) === itemId ? { ...prev, landUseCertificate: finalUrl } : prev
            );

            toast.success('Land use certificate uploaded successfully');
        } catch (error) {
            const message = error?.message || 'Failed to upload land use certificate';
            setLandUseUploadErrorById((prev) => ({ ...prev, [itemId]: message }));
            toast.error(message);
        } finally {
            setLandUseUploadingById((prev) => ({ ...prev, [itemId]: false }));
        }
    };

    const handleRemoveLandUseCertificate = async (item) => {
        if (!item?._id) return;
        const itemId = String(item._id);
        const userId = item?.userId || userDetails?.user_id;
        if (!userId) {
            toast.error('User not found');
            return;
        }
        setLandUseUploadingById((prev) => ({ ...prev, [itemId]: true }));
        setLandUseUploadErrorById((prev) => ({ ...prev, [itemId]: '' }));
        try {
            const updatePayload = {
                KypId: itemId,
                _id: itemId,
                userId,
                landUseCertificate: '',
            };
            const updateResponse = await PropertiesService.updateKnowYourProperty(updatePayload);
            if (typeof updateResponse === 'string' && updateResponse.toLowerCase().includes('error')) {
                throw new Error(updateResponse);
            }
            setKyplist((prev) =>
                prev.map((kyp) =>
                    String(kyp?._id) === itemId ? { ...kyp, landUseCertificate: '' } : kyp
                )
            );
            setKpiFilter((prev) =>
                prev.map((kyp) =>
                    String(kyp?._id) === itemId ? { ...kyp, landUseCertificate: '' } : kyp
                )
            );
            setSelectedItem((prev) =>
                prev && String(prev?._id) === itemId ? { ...prev, landUseCertificate: '' } : prev
            );
            toast.success('Land use certificate removed');
        } catch (error) {
            const message = error?.message || 'Failed to remove land use certificate';
            setLandUseUploadErrorById((prev) => ({ ...prev, [itemId]: message }));
            toast.error(message);
        } finally {
            setLandUseUploadingById((prev) => ({ ...prev, [itemId]: false }));
        }
    };

    const showPaymentGatewayModel = () => {
        showGatewayModel(true)
    }

    const ocSealCode = generateUniqueSealCode(
        socCertificateData?.certificateId,
        selectedCertificateItem?.ownerName || userDetails?.name,
        socCertificateData?.createdAt || selectedCertificateItem?.updatedAt || selectedCertificateItem?.createdAt
    );

    if (editingKypId) {
        return (
            <KnowYourProperty
                propertyRequestSwitch="Know Your Property"
                ShowPrevousData={true}
                closeModal={closeKypEditModal}
                editKypId={editingKypId}
            />
        );
    }

    return (
        <>
            {showSocCertificate && selectedCertificateItem && (
                <div className="soc-modal-overlay">
                    {/* <div className="soc-modal-content wide-modal"> */}
                    <div className="kyp-oc-view animate-fadeIn">
                        <div className="kyp-oc-certificate" ref={certificateRef}>
                            <button className="kyp-oc-close" onClick={() => setShowSocCertificate(false)}>✕</button>
                            <button className="kyp-oc-download" data-export-hide="true" data-html2canvas-ignore="true" onClick={downloadCertificate} disabled={isDownloading}>
                                <FaDownload size={16} /> {isDownloading ? 'Downloading...' : 'Download'}
                            </button>

                            <div className="kyp-oc-header">
                                <div className="soc-header-text">
                                    <img src={logo} alt="Docity logo" className="kyp-oc-logo-top" />
                                    <h3>Ownership Certificate</h3>
                                </div>
                            </div>

                            <p className="kyp-oc-declaration">
                                <span className="kyp-oc-declaration-line">This is to acknowledge and certify that</span>
                                <span className="kyp-oc-owner-highlight">{selectedCertificateItem?.ownerName || userDetails?.name || 'Property Owner'}</span>
                                <span className="kyp-oc-declaration-line">is the rightful owner / occupier of the property submitted to DoCity Civil Engineers Private Limited.</span>
                                <span className="kyp-oc-declaration-line">The details and supporting documents provided for this application are accepted as true to the best of the applicant's knowledge.</span>
                            </p>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '0 16px 10px 16px', gap: '16px' }}>
                                <div style={{ flex: 1 }}>
                                    <span className="kyp-oc-label" style={{ display: 'block' }}>ADDRESS</span>
                                    <span style={{ fontSize: '0.75rem', wordBreak: 'break-word' }}>
                                        {getKypAddress(selectedCertificateItem) || 'Address not available'}
                                    </span>
                                </div>
                                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                                    <span className="kyp-oc-label" style={{ display: 'block' }}>CERTIFICATE EXPIRY</span>
                                    <span style={{ fontSize: '0.75rem' }}>{formatDisplayDate(socCertificateData?.expiresAt)}</span>
                                </div>
                            </div>

                            <div className="kyp-oc-footer-grid">
                                <div className="kyp-oc-address-block">
                                    <div className="kyp-oc-meta-col">
                                        <div className="kyp-oc-qr-center kyp-oc-qr-below-owner">
                                            <div className="kyp-oc-qr-frame">
                                                {effectiveQrCode || socCertificateData?.qrCodeData ? (
                                                    <a
                                                        href={
                                                            socCertificateData?.downloadUrl ||
                                                            socCertificateData?.certificateDownloadUrl ||
                                                            socCertificateData?.pdfUrl ||
                                                            socCertificateData?.certificateUrl ||
                                                            buildCertificateDownloadRoute('oc', socCertificateData?.certificateId || selectedItem?.OCCertificateId, {
                                                                ownerName: socCertificateData?.ownerName || selectedItem?.ownerName || '',
                                                                address: socCertificateData?.address || selectedItem?.location || selectedItem?.address || '',
                                                                expiresAt: socCertificateData?.expiresAt || '',
                                                                issuedAt: socCertificateData?.createdAt || selectedItem?.createdAt || '',
                                                            }) ||
                                                            "#"
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <img src={effectiveQrCode || socCertificateData.qrCodeData} className="kyp-oc-qr" alt="QR Code" crossOrigin="anonymous" />
                                                    </a>
                                                ) : (
                                                    <FaQrcode size={56} />
                                                )}
                                            </div>
                                            <span className="kyp-oc-qr-caption">Scan to download certificate</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="kyp-oc-seal-wrap">
                                    <div className="kyp-oc-seal" aria-label={`Unique seal ${ocSealCode}`}>
                                        <svg viewBox="0 0 200 200" className="kyp-oc-seal-svg" role="img" aria-label="Docity company seal">
                                            <defs>
                                                <path id="kypSealTopArc" d="M 28 100 A 72 72 0 0 1 172 100" />
                                                <path id="kypSealBottomArc" d="M 172 100 A 72 72 0 0 1 28 100" />
                                            </defs>

                                            <circle cx="100" cy="100" r="90" className="kyp-seal-ring-outer" />
                                            <circle cx="100" cy="100" r="62" className="kyp-seal-ring-mid" />

                                            <text className="kyp-seal-text-arc kyp-seal-text-top">
                                                <textPath href="#kypSealTopArc" startOffset="50%" textAnchor="middle">DOCITY.CO.IN</textPath>
                                            </text>
                                            <text className="kyp-seal-text-arc kyp-seal-text-bottom">
                                                <textPath href="#kypSealBottomArc" startOffset="50%" textAnchor="middle">THE DOCITY SEAL</textPath>
                                            </text>

                                            <text x="100" y="84" className="kyp-seal-company" textAnchor="middle">DOCITY SEAL</text>
                                            <image href={logo} x="82" y="90" width="36" height="36" preserveAspectRatio="xMidYMid meet" className="kyp-seal-logo-svg" />
                                        </svg>
                                    </div>
                                </div>

                                <div className="kyp-oc-sign-wrap">
                                    <strong style={{
                                        fontFamily: "'Brush Script MT', 'Dancing Script', 'Georgia', cursive, serif",
                                        fontSize: '26px',
                                        fontWeight: '500',
                                        fontStyle: 'italic',
                                        color: 'var(--ds-navy-700)',
                                        display: 'inline-block',
                                        marginBottom: '2px',
                                        whiteSpace: 'nowrap'
                                    }}>DoCity</strong>
                                    <div className="kyp-oc-sign-line" />
                                    <span>Authorised Signature</span>
                                </div>
                            </div>
                            <div className='disclaimer-text'>
                                <p className='dis-text'>DoCity does not take responsibility for the title or possession of this property.</p>
                            </div>
                        </div>
                        {/* </div> */}
                    </div>
                </div>
            )}
            {showKypVoucher && selectedCertificateItem && (
                <div className="soc-modal-overlay">
                    <div className="kyp-oc-view animate-fadeIn">
                        <div className="kyp-oc-certificate kyp-voucher-certificate">
                            <button className="kyp-oc-close" onClick={() => setShowKypVoucher(false)}>✕</button>
                            <div className="kyp-voucher-layout">
                                <div className="kyp-voucher-left-panel">
                                    <div className="kyp-voucher-amount-badge">KYP</div>
                                </div>

                                <div className="kyp-voucher-right-panel">
                                    <div className="kyp-voucher-brand-row">
                                        <img src={logo} alt="Docity logo" className="kyp-voucher-logo" />
                                        <span className="kyp-voucher-brand-name">DoCity</span>
                                    </div>

                                    <h2 className="kyp-voucher-title">VOUCHER</h2>
                                    <p className="kyp-voucher-subtitle">Property Verification Voucher</p>

                                    <div className="kyp-voucher-info-grid">
                                        <div className="kyp-voucher-name-col">
                                            <span className="kyp-oc-label">Name of the Authorised</span>
                                            <p>{selectedCertificateItem?.ownerName || userDetails?.name || 'Authorised Name'}</p>
                                        </div>
                                        <div className="kyp-voucher-expiry-col">
                                            <span className="kyp-oc-label">Expiry Date</span>
                                            <p>{formatDisplayDate(getVoucherExpiryDate(selectedCertificateItem, socCertificateData))}</p>
                                        </div>
                                        <div className="kyp-voucher-address-row">
                                            <span className="kyp-oc-label">Property Address</span>
                                            <p>{getKypAddress(selectedCertificateItem) || 'Address not available'}</p>
                                        </div>
                                    </div>

                                    <div className="kyp-voucher-bottom-row">
                                        <div className="kyp-voucher-qr-wrap">
                                            <div className="kyp-oc-qr-frame">
                                                {effectiveQrCode || socCertificateData?.qrCodeData ? (
                                                    <a
                                                        href={
                                                            socCertificateData?.downloadUrl ||
                                                            socCertificateData?.certificateDownloadUrl ||
                                                            socCertificateData?.pdfUrl ||
                                                            socCertificateData?.certificateUrl ||
                                                            buildCertificateDownloadRoute('oc', socCertificateData?.certificateId || selectedItem?.OCCertificateId) ||
                                                            "#"
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <img src={effectiveQrCode || socCertificateData.qrCodeData} className="kyp-oc-qr" alt="QR Code" crossOrigin="anonymous" />
                                                    </a>
                                                ) : (
                                                    <FaQrcode size={56} />
                                                )}
                                            </div>
                                            <span className="kyp-oc-qr-caption">QR Code</span>
                                        </div>

                                        <div className="kyp-voucher-seal-wrap">
                                            <div className="kyp-oc-seal" aria-label="Docity seal">
                                                <svg viewBox="0 0 200 200" className="kyp-oc-seal-svg" role="img" aria-label="Docity company seal">
                                                    <defs>
                                                        <path id="kypVoucherTopArc" d="M 28 100 A 72 72 0 0 1 172 100" />
                                                        <path id="kypVoucherBottomArc" d="M 172 100 A 72 72 0 0 1 28 100" />
                                                    </defs>

                                                    <circle cx="100" cy="100" r="90" className="kyp-seal-ring-outer" />
                                                    <circle cx="100" cy="100" r="62" className="kyp-seal-ring-mid" />

                                                    <text className="kyp-seal-text-arc kyp-seal-text-top">
                                                        <textPath href="#kypVoucherTopArc" startOffset="50%" textAnchor="middle">DOCITY.CO.IN</textPath>
                                                    </text>
                                                    <text className="kyp-seal-text-arc kyp-seal-text-bottom">
                                                        <textPath href="#kypVoucherBottomArc" startOffset="50%" textAnchor="middle">THE DOCITY SEAL</textPath>
                                                    </text>

                                                    <text x="100" y="84" className="kyp-seal-company" textAnchor="middle">DOCITY SEAL</text>
                                                    <image href={logo} x="82" y="90" width="36" height="36" preserveAspectRatio="xMidYMid meet" className="kyp-seal-logo-svg" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='disclaimer-text kyp-voucher-disclaimer'>
                                        <p className='dis-text'>DoCity does not take responsibility for the title or possession of this property.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {KypListLoading == false ?
                <>

                    {!showDetails && (
                        <div className="soc-list-main-section">
                            {/* Top Header */}


                            {/* Main Table Card */}
                            <div className="soc-table-card">
                                {/* Controls */}
                                <div className="soc-table-controls">
                                    <div className="soc-table-search-wrap">
                                        <FaUser className="soc-search-icon" size={16} style={{ color: 'var(--ds-navy-300)', position: 'absolute', left: '12px' }} />
                                        <input
                                            type="search"
                                            className="soc-table-search-input"
                                            onChange={handleSearch}
                                            value={searchTerm}
                                            placeholder="Search by owner name, location or address..."
                                        />
                                    </div>
                                    <div className="soc-table-right-controls">
                                        <div className="soc-sort-dropdown-wrap">
                                            <span className="soc-sort-label">Sort:</span>
                                            <select
                                                className="soc-sort-select"
                                                defaultValue="latest"
                                                onChange={(e) => {
                                                    const order = e.target.value;
                                                    const sorted = [...kpifilter].sort((a, b) => {
                                                        const tA = new Date(a?.updatedAt || a?.createdAt || 0).getTime();
                                                        const tB = new Date(b?.updatedAt || b?.createdAt || 0).getTime();
                                                        return order === 'latest' ? tB - tA : tA - tB;
                                                    });
                                                    setKpiFilter(sorted);
                                                    setCurrentPage(1);
                                                }}
                                            >
                                                <option value="latest">Latest First</option>
                                                <option value="oldest">Oldest First</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* Table */}
                                <div className="soc-table-responsive">
                                    <table className="soc-data-table">
                                        <thead>
                                            <tr>
                                                <th>Property</th>
                                                <th>Contact Info</th>
                                                <th>Property Details</th>
                                                <th>Submitted On</th>
                                                <th className="text-right">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentItems.length > 0 ? (
                                                currentItems.map((item, index) => (
                                                    <tr key={item._id || index}>
                                                        <td>
                                                            <div className="soc-cert-cell" style={{ cursor: 'pointer' }} onClick={() => handleCardClick(item)}>
                                                                <div className="soc-cert-icon-box">
                                                                    <FaHome size={18} style={{ color: 'var(--ds-teal-700)' }} />
                                                                </div>
                                                                <div>
                                                                    <span className="soc-cert-code">Property #{indexOfFirstItem + index + 1}</span>
                                                                    <div style={{ fontSize: '0.8rem', color: 'var(--ds-text-secondary)', marginTop: '2px', maxWidth: '320px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                                                        title={getKypAddress(item)}>
                                                                        {item.ownerName && <span style={{ fontWeight: 600, color: 'var(--ds-navy-700)' }}>{item.ownerName} &mdash; </span>}
                                                                        {getKypAddress(item) || item.location || 'No Address'}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div style={{ fontSize: '0.825rem', color: 'var(--ds-navy-700)', fontWeight: 500 }}>
                                                                {item.email || 'N/A'}
                                                            </div>

                                                        </td>
                                                        <td>
                                                            <div style={{ fontSize: '0.825rem', color: 'var(--ds-navy-700)', fontWeight: 500 }}>
                                                                {item.typeOfProperty || 'N/A'}
                                                            </div>
                                                            {item.buildingAge && (
                                                                <div style={{ fontSize: '0.75rem', color: 'var(--ds-text-secondary)', marginTop: '2px' }}>
                                                                    Age: {item.buildingAge} years
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <span className="soc-issuance-date">
                                                                {new Date(item.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                                            </span>
                                                        </td>
                                                        <td className="text-right">
                                                            <div className="soc-actions-cell">
                                                                <button
                                                                    className="soc-action-btn view-btn"
                                                                    onClick={() => handleCardClick(item)}
                                                                >
                                                                    <FaBuilding size={14} />
                                                                    <span>View</span>
                                                                </button>
                                                                <button
                                                                    className="soc-action-btn edit-btn"
                                                                    onClick={(event) => openKypEditModal(item, event)}
                                                                >
                                                                    <FaEdit size={13} />
                                                                    <span>Edit</span>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5">
                                                        <div className="soc-empty-table-state">
                                                            <p>{kpifilter.length === 0 ? 'You have not requested a property review yet. Request your first Know Your Property (KYP) review to get started.' : 'Try refining your search query.'}</p>
                                                            {kpifilter.length === 0 && (
                                                                <a href="/" style={{ color: 'var(--color-turquoise-teal)', textDecoration: 'underline' }}>
                                                                    Click here to request a KYP.
                                                                </a>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination */}
                                {filteredList.length > 0 && (
                                    <div className="soc-table-footer">
                                        <div className="soc-footer-info">
                                            Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredList.length)} of {filteredList.length} records
                                        </div>
                                        <div className="soc-table-pagination-controls">
                                            <button
                                                className="soc-page-nav-btn"
                                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                disabled={currentPage === 1}
                                            >
                                                ‹
                                            </button>
                                            {Array.from({ length: Math.ceil(filteredList.length / itemsPerPage) }, (_, i) => i + 1).map(p => (
                                                <button
                                                    key={p}
                                                    className={`soc-page-num-btn ${currentPage === p ? 'active' : ''}`}
                                                    onClick={() => setCurrentPage(p)}
                                                >
                                                    {p}
                                                </button>
                                            ))}
                                            <button
                                                className="soc-page-nav-btn"
                                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(filteredList.length / itemsPerPage)))}
                                                disabled={currentPage === Math.ceil(filteredList.length / itemsPerPage)}
                                            >
                                                ›
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    {showDetails && selectedItem && (
                        <KypDetailsUiCard backbtnclk={backbtnclk}
                            tabs={tabs} setActiveTab2={setActiveTab2} activeTab2={activeTab2} FaUser={FaUser} userIcon={userIcon} selectedItem={selectedItem}
                            FaCheckCircle={FaCheckCircle} FaIdCard={FaIdCard} FaEnvelope={FaEnvelope} FaPhone={FaPhone} FaBuilding={FaBuilding}
                            FaMapMarkerAlt={FaMapMarkerAlt} FaCalendarAlt={FaCalendarAlt} FaMoneyBillWave={FaMoneyBillWave} FaFileAlt={FaFileAlt}
                            FaFileInvoiceDollar={FaFileInvoiceDollar} FaHardHat={FaHardHat} FaRoad={FaRoad} FaUserTie={FaUserTie}
                            FaTools={FaTools} FaUniversity={FaUniversity} FaDraftingCompass={FaDraftingCompass} FaToolbox={FaToolbox} FaInfoCircle={FaInfoCircle}
                            FaMountain={FaMountain} FaClock={FaClock} FaFilePdf={FaFilePdf} activeTabnew={activeTabnew} setActiveTabNew={setActiveTabNew}
                            onLoad3={onLoad3} onError={onError} hasError={hasError} directions={directions} activeTab4={activeTab4} setActiveTab4={setActiveTab4}
                            currentNeighbour={currentNeighbour} ProgressbarForKypForm={ProgressbarForKypForm}
                            onViewSocCertificate={handleViewSocCertificate}
                            onViewKypVoucher={handleViewKypVoucher}
                            isSocGenerating={generatingSocId === (selectedItem?._id || selectedItem?.id)}
                            hasSocCertificate={Boolean(
                                selectedItem?.OCCertificateId ||
                                socCertificateMap[getKypItemKey(selectedItem)] ||
                                socHistoryByKypId[getKypItemKey(selectedItem)]
                            )}
                            onUploadLandUseCertificate={handleUploadLandUseCertificate}
                            onRemoveLandUseCertificate={handleRemoveLandUseCertificate}
                            isLandUseUploading={!!landUseUploadingById[String(selectedItem?._id || '')]}
                            landUseUploadError={landUseUploadErrorById[String(selectedItem?._id || '')] || ''}
                        />)
                    }
                    {showPaymentModal && (
                        <div className="custom-modal-overlay">
                            <div className="custom-modal">
                                <div className="modal-header">
                                    <div className="row setCenter">
                                        <div className="col-md-4">
                                            {GatewayModel == true && <div onClick={() => showGatewayModel(false)} className='hoverText' >X</div>}
                                        </div>
                                    </div>
                                </div>
                                {GatewayModel == false ?
                                    <>
                                        <div className="modal-body">
                                            <PaymentPreviewCard
                                                baseAmount={2000}
                                                gstRate={18}
                                                servicePoints={[
                                                    "Ownership Certificate",
                                                    "I hereby solemnly declare that all the information provided by me in respect of the property submitted is true, accurate, and complete to the best of my knowledge and belief.",
                                                    "Market Plan and Land Use Certificate declaration",
                                                    "Bank loan preference declaration",
                                                    "Title possession protection consent",
                                                    "Consent for sharing details with banks, insurance, and government departments",
                                                ]}
                                            />
                                            <p style={{ color: 'var(--color-oxford-blue)', padding: '20px' }}>Payment has not been completed for this property. Please complete the payment to continue.</p>
                                        </div>
                                        <div className="modal-footer-custom">
                                            <button className="btn btn-secondary" onClick={() => setShowPaymentModal(false)}>Close</button>&nbsp;&nbsp;&nbsp;
                                            <button
                                                className="btn btn-primary"
                                                onClick={() => showPaymentGatewayModel()}>
                                                Proceed to pay
                                            </button>
                                        </div>
                                    </>
                                    :
                                    <Product
                                        amount={2000}
                                        gstRate={18}
                                        currency="INR"
                                        paymentFor="knowYourProperty"
                                        userId={selectedItem?.userId}
                                        onPaymentStatusChange={setPaymentStatus}
                                        paymentRequestId={selectedItem}
                                        paymentStatus={paymentStatus}
                                        paymentMessage="KYP"
                                        SuccessStatus="AfterRequest"
                                    />
                                }
                            </div>
                        </div>
                    )}
                </>
                : <div className="loader-container222">
                    <div className="setInCenter"><FetchingCard message="" sub="Fetching details" /> </div>
                </div>}
        </>
    );
};

export default KYPList;

